import script from "./PwdPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PwdPage.vue?vue&type=script&setup=true&lang=js"

import "./PwdPage.vue?vue&type=style&index=0&id=2282a735&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2282a735"]])

export default __exports__